import { useEffect, useState } from 'react';
import axios from 'axios';
import { Layout } from '@/components/Layout';
import { PickCard } from '@/components/PickCard';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function PickHistory() {
  const [picks, setPicks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPicks = async () => {
      try {
        const response = await axios.get(`${API}/picks`);
        // Group picks by date
        const groupedPicks = response.data.reduce((acc, pick) => {
          const date = new Date(pick.pick_date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
          if (!acc[date]) {
            acc[date] = [];
          }
          acc[date].push(pick);
          return acc;
        }, {});
        setPicks(groupedPicks);
      } catch (error) {
        console.error('Failed to fetch picks:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPicks();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-screen" data-testid="loading-indicator">
          <Loader2 className="animate-spin" size={40} />
        </div>
      </Layout>
    );
  }

  const dates = Object.keys(picks).sort((a, b) => new Date(b) - new Date(a));

  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12" data-testid="pick-history-page">
        <div className="mb-12">
          <h1 className="text-5xl md:text-6xl font-heading font-bold mb-4">PICK HISTORY</h1>
          <p className="text-lg text-muted-foreground">Complete archive of all picks with full analysis</p>
        </div>

        {dates.length === 0 ? (
          <div className="text-center py-20" data-testid="no-picks">
            <p className="text-xl text-muted-foreground">No picks in history yet.</p>
          </div>
        ) : (
          <div className="space-y-12">
            {dates.map((date) => (
              <div key={date} data-testid={`date-${date}`}>
                <h2 className="text-3xl font-heading font-bold mb-6 pb-4 border-b border-border">
                  {date}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {picks[date].map((pick) => (
                    <PickCard key={pick.id} pick={pick} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
